export const imageFileExtensions = [
  "bmp",
  "gif",
  "ief",
  "jpg",
  "jpe",
  "jpeg",
  "heic",
  "heif",
  "png",
  "svg",
  "tiff",
  "tif",
  "ico",
  "ras",
  "pnm",
  "pbm",
  "pgm",
  "ppm",
  "rgb",
  "xbm",
  "xpm",
  "xwd",
];

export const allowedExtensions = [
  "pdf",
  "doc",
  "dot",
  "wiz",
  "bin",
  "a",
  "dll",
  "exe",
  "o",
  "obj",
  "so",
  "oda",
  "p7c",
  "ps",
  "ai",
  "eps",
  "m3u",
  "m3u8",
  "xls",
  "xlb",
  "ppt",
  "pot",
  "ppa",
  "pps",
  "pwz",
  "wasm",
  "bcpio",
  "cpio",
  "csh",
  "dvi",
  "gtar",
  "hdf",
  "h5",
  "latex",
  "mif",
  "cdf",
  "nc",
  "p12",
  "pfx",
  "ram",
  "pyc",
  "pyo",
  "sh",
  "shar",
  "swf",
  "sv4cpio",
  "sv4crc",
  "tar",
  "tcl",
  "tex",
  "texi",
  "texinfo",
  "roff",
  "t",
  "tr",
  "man",
  "me",
  "ms",
  "ustar",
  "src",
  "xsl",
  "rdf",
  "wsdl",
  "xpdl",
  "zip",
  "3gp",
  "3gpp",
  "3g2",
  "3gpp2",
  "aac",
  "adts",
  "loas",
  "ass",
  "au",
  "snd",
  "mp3",
  "mp2",
  "opus",
  "aif",
  "aifc",
  "aiff",
  "ra",
  "wav",
  "eml",
  "mht",
  "mhtml",
  "nws",
  "css",
  "csv",
  "html",
  "htm",
  "txt",
  "bat",
  "c",
  "h",
  "ksh",
  "pl",
  "rtx",
  "tsv",
  "py",
  "etx",
  "sgm",
  "sgml",
  "vcf",
  "xml",
  "mp4",
  "mpeg",
  "m1v",
  "mpa",
  "mpe",
  "mpg",
  "mov",
  "qt",
  "webm",
  "avi",
  "movie",
  "js",
  "mjs",
  "json",
  "webmanifest",
  "docx",
  "xlsx",
  "xlsm",
  "pptx",
  "msg",
  ...imageFileExtensions,
];
